<script lang="ts">
	import { NewsProfileComponent } from './NewsProfileComponent';
	import { page } from '$app/state';
	import type { NewsHomePageData } from '$routes/news/types';

	let data = $derived(page.data as NewsHomePageData);
	let profile = $derived(data.profile);
</script>

<div class="flex flex-col gap-8">
	{#each profile?.profile_components || [] as component (component?.HENI_News_Profile_Components_id?.id || component?.id)}
		{#if component.HENI_News_Profile_Components_id}
			<NewsProfileComponent
				component={component.HENI_News_Profile_Components_id}
			/>
		{/if}
	{/each}
</div>
